import Colors from './colors';

export default Colors;
